
import React from "react";
import { IMerchItem } from "../../data";
import styles from "../../assets/style.module.css";

export interface ProductCardProps {
    item: IMerchItem;
    action?: React.ReactNode;
}

function ProductCard({ item, action }: ProductCardProps) {
    return (<div className={styles["product"]}>
        <div className={styles["product-media"]}>
            <img className={styles["product-img"]} src={item.img} alt={item.name} loading="lazy" />
            {item.hoverImg && (<img className={styles["product-img-hover"]} src={item.hoverImg} alt="" loading="lazy" />)}
            {item.badge && (<span className={styles["card-badge"]}>{item.badge}</span>)}
        </div>
        <h3 className={styles["product-title"]}>{item.name}</h3>
        <div className={styles["product-foot"]}>
            <span className={styles["product-cat"]}>{item.category}</span>
            <span className={styles["product-price"]}>${item.price.toFixed(2)}</span>
        </div>
        {action}
    </div>);
}

export default ProductCard;
